// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__EuTJ8","savePackageButton":"ClientWallet_savePackageButton__ZQMjt"};